import styled from "styled-components";

export default styled.div`
  display: flex;
  width: 100%;
  font-size: 1rem;
  align-items: center;
  margin: 1rem 0 0 3.5rem;

  & > span {
    margin-left: 0.5rem;
    font-size: 1.2rem;
  }

  @media (min-width: 550px) {
    font-size: 1.3rem;
    // margin: 1rem 0 0 4rem;
    margin: 1rem 0 0 0;

    & > span {
      font-size: 1.7rem;
    }
  }
`;
